import React from 'react';
import { useTranslation } from 'react-i18next';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import styles from './SidebarPinToggle.module.scss';

interface SidebarPinToggleProps {
  isPinned: boolean;
  onToggle: () => void;
}

/**
 * Opens the menu to full width or collapses it to an icon rail. This is the
 * only way between the two states — the rail deliberately ignores the pointer —
 * so the control has to stay visible in both. Hidden on phones, where the menu
 * is a drawer driven by the header's hamburger instead.
 */
const SidebarPinToggle: React.FC<SidebarPinToggleProps> = ({ isPinned, onToggle }) => {
  const { t } = useTranslation();
  const label = t(isPinned ? 'sidebar.collapse' : 'sidebar.expand');

  return (
    <button
      type="button"
      className={styles.toggleButton}
      onClick={onToggle}
      aria-expanded={isPinned}
      aria-label={label}
      title={label}
    >
      <ChevronLeftIcon fontSize="small" className={styles.chevron} />
    </button>
  );
};

export default SidebarPinToggle;
